import { Exclusion, ExclusionsFilters } from '../types/exclusion-types';
import ExclusionsStore from '../stores/exclusions-store';
import { Nullable } from 'common-types';
import { snapshot } from 'valtio';
import { FilterElements } from '../../common/filters-utils/filters-utils';

export const setExclusions = (exclusions: Exclusion[], update?: boolean) => {
  if (update) {
    ExclusionsStore.exclusions = exclusions;
  } else {
    ExclusionsStore.exclusions?.push(...exclusions);
  }
};

export const setSelectedExclusion = (exclusion: Nullable<Exclusion>) => {
  ExclusionsStore.selectedExclusion = exclusion;
};

export const setExclusionsError = (isError: boolean, errorMessage: string) => {
  ExclusionsStore.generalError = isError;
  ExclusionsStore.errorMessage = errorMessage;
};

export const setModalAction = (isShowing: boolean): void => {
  ExclusionsStore.showModal = isShowing;
};

export const setIsDisablePolicyLoading = (isDisablePolicyLoading: boolean) => {
  ExclusionsStore.isDisablePolicyLoading = isDisablePolicyLoading;
};

export const setIsApplicationIrrelevantLoading = (
  isDisableApplicationLoading: boolean,
) => {
  ExclusionsStore.isIrrelevantApplicationLoading = isDisableApplicationLoading;
};

export const setIsExcludeAlertLoading = (isExcludeAlertLoading: boolean) => {
  ExclusionsStore.isExcludeAlertLoading = isExcludeAlertLoading;
};

export const setIsRemoveExclusionLoading = (
  isRemoveExclusionLoading: boolean,
) => {
  ExclusionsStore.isRemoveExclusionLoading = isRemoveExclusionLoading;
};

export const setIsUpdateExpiredAtByIdLoading = (
  isUpdateExpiredAtById: boolean,
) => {
  ExclusionsStore.isUpdateExpiredAtById = isUpdateExpiredAtById;
};

export const setModalUpdateExpiredAt = (isShowing: boolean): void => {
  ExclusionsStore.updateExpiredAtModal = isShowing;
};

export const setModalUpdateExpiredAtBanner = (banner: boolean): void => {
  ExclusionsStore.updateExpiredAtModalBanner = banner;
};

export const setIsLoadingRemoveSnooze = (isLoading: boolean) => {
  ExclusionsStore.removeSnoozeLoading = isLoading;
};

export const setModalRemoveSnooze = (isShowing: boolean): void => {
  ExclusionsStore.removeSnoozeModal = isShowing;
};

export const setTotalExclusionsNumber = (totalExclusions: number) => {
  ExclusionsStore.totalExclusions = totalExclusions;
};

export const setTotalExclusionsFiltersNumber = (
  totalExclusionsFilters: number,
) => {
  ExclusionsStore.totalFilteredExclusions = totalExclusionsFilters;
};

export const setExpireDate = (expiredAt?: Nullable<Date>) => {
  if (ExclusionsStore.selectedExclusion) {
    ExclusionsStore.selectedExclusion.expiredAt = expiredAt;
  }
};

export const setBannerSnoozeDay = (show: boolean) => {
  ExclusionsStore.bannerSnoozeDay = show;
};

export const setBannerSnoozeWeek = (show: boolean) => {
  ExclusionsStore.bannerSnoozeWeek = show;
};

export const setExclusinsExpiredWeek = (exclusinsExpired: Exclusion[]) => {
  ExclusionsStore.exclusionsExpiredWeek = exclusinsExpired;
};

export const setExclusionsFilters = (exclusionsFilters: ExclusionsFilters) => {
  ExclusionsStore.exclusionsFiltersTypes = exclusionsFilters;
};

export const setStoreExclusionsFiltersTypeSearch = (
  exclusionsFilters: ExclusionsFilters,
): void => {
  const { searchValues } = snapshot(ExclusionsStore);
  ExclusionsStore.exclusionsFiltersTypeSearch = Object.keys(
    exclusionsFilters,
  ).reduce((acc, key) => {
    acc[key] = searchValues[key]
      ? exclusionsFilters[key].filter((f: FilterElements) =>
          f.label.toLocaleLowerCase().includes(searchValues[key].toLowerCase()),
        )
      : exclusionsFilters[key];
    return acc;
  }, {} as ExclusionsFilters);
};

export const setSearchValues = (type: string, searchValue: string) => {
  ExclusionsStore.searchValues[type] = searchValue;
};
